import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Button, SecondaryButton, PageLink } from "../StyledComp/StyledComp";
import { IEvent } from "../../store/eventApiSlice";
import orderApiSlice, {
  ICost,
  ILocation,
  IMembership,
  IOrderItem,
  storeAddOrderItem,
  storeUpdateOrder,
  storeUpdateSectionItem,
  storeUpdateSectionOrderItem,
  storeUpdateVideoItem,
  resetOrderParameters,
  initalOrderItem,
  // storeAddTransactionAmount,
} from "../../store/orderApiSlice";
import { Cost } from "../../store/eventApiSlice";
import IMember, {
  IMemberSections,
  IPaymentInfo,
} from "../../store/memberInterfaceStruct";
import MemberServices from "../../services/MemberServices";
import OrderEditSectionMultipleOptionItems from "./OrderEditSectionMultipleOptionItems";
import OrderServices from "../../services/OrderServices";
import { Section } from "../../globalStyles";
import { isNull } from "util";
import ReactModal from "react-modal";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { updateCurrentMember } from "../../store/currentMemberSlice";
import { useNavigate } from "react-router-dom";
import AlertWithModal from "../utilityComponents/AlertWithModal";

// interface Cost {
//   Id: number | null;
//   CostName: string | null;
//   Cost: number | null;
//   EventId: number | null;
// }

// interface ILocation {
//   Id: number | null;
//   Location: String | null;
//   Cost: number | null;
// }

interface IConfiguration {
  [key: string]: any;
}

interface IMemberShipOrderDetailUpdated {
  SectionName: string;
  Id: number;
  Fee: number;
  SectionDescription: string | null;
  IsSelected: boolean;
  IsCurrentYearSection: boolean;
  IsCurrentYearSectionNotPaid: boolean;
  IsLastYearSection: boolean;
}

interface IActiveOrder {
  FunctioOrders: any[];
  SeminarOrders: any[];
  memberShipOrderDetails: IMemberShipOrders[];
  memberShipOrderDetailsUpdated?: IMemberShipOrderDetailUpdated[];
}

interface IMemberCode {
  Id: number;
  MemberCode: string;
  Description: string;
  Fee: number;
  FromYear: number;
  AdvanceMemberCode: string;
  Status: number;
}

interface IProp {
  // eventList: IEvent[];
  eventType: string;
  currentMember: IMember;
  membersActiveOrders: IActiveOrder;
  Sections?: ISection[];
  memberCodes?: IMemberCode[];
  videoEvents?: IEvent[];
  onEventScreenChange: (eventScreen: string) => void;
}

interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  isSelected: boolean;
}

interface ISelectedSections {
  Id: number | null;
  SectionName: string | null;
  MemberId: number | null;
}

// interface IFunctionOrders {
//   MemberId: number | null;
//   OrderId: number | null;
//   EventId: number | null;
//   LocationId: number | null;
//   CostId: number | null;
// }

// interface ISeminarOrders {
//   MemberId: number | null;
//   OrderId: number | null;
//   EventId: number | null;
//   LocationId: number | null;
//   CostId: number | null;
// }

interface IMemberShipOrders {
  Id: number | null;
  OrderId: number | null;
  MemberId: number | null;
  MemberCodeId: number | null;
  LastYearSections: string | null;
  CurrentYearSections: string | null;
  CurrentYearSectionsNotPaid: string | null;
  Description: string | null;
  Fee: number | null;
  MemberCode: string | null;
}

const OrderEventDetail: React.FC<IProp> = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const form = useForm<IPaymentInfo>();
  const { control } = form;

  const eventInfo = useAppSelector((store) => store.eventapislice.event);
  // console.log("eventInfo", eventInfo);
  let storeTrasactionAmount = useAppSelector(
    (store) => store.orderapislice.TotalAmount
  );

  const currentMember = useAppSelector((state) => state.currentMember);
  const [tempCurrentMember, setTempCurrentMember] = useState(
    props.currentMember
  );
  const [currentMemberCodeId, setCurrentMemberCodeId] = useState(
    currentMember.MemberCodeId
  );
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [totalAmount, setTotalAmount] = useState<number>(0);

  const [participantType, setParticipantType] = useState<string>("Attendee");
  console.log("currentMember", currentMember);
  console.log("tempCurrentMember", tempCurrentMember);
  // Temp useeffect, will be removed after API change
  // const [configurationList, setConfigurationList] = useState<IConfiguration>(
  //   {}
  // );

  const [callAPIflag, setCallAPIflag] = useState<boolean>(false);
  const orderDetail = useAppSelector((store) => store.orderapislice);
  const [orderItemsForComputeCost, setOrderItemsForComputeCost] = useState<
    IOrderItem[]
  >(orderDetail?.Orders);
  const [textarea, setTextarea] = useState("");

  const membershipItem: IMembership = {
    EventType: "",
    Id: 0,
    SectionName: "",
    Fee: 0,
  };

  let orderItem: IOrderItem = { ...initalOrderItem };
  // const orderItem: IOrderItem = {
  //   EventId: "0",
  //   MemberCodeId: null,
  //   Locations: null,
  //   Costs: [],
  //   EventName: "",
  //   OrderType: "",
  //   MemberCode: "",
  //   MemberCodeFee: null,
  //   MemberCodeDesc: "",
  //   EventType: "",
  //   ParticipantType: "Attendee",
  //   LastYearSections: [],
  //   CurrentYearSections: [],
  //   membershipItemList: [],
  //   VideoCost: 0,
  // };

  let SelectedSections: IMemberSections[] | null;
  SelectedSections = currentMember!.MemberSections;

  const sectionArray = SelectedSections?.map((section) => {
    return section.Id;
  });

  const [selectedItems, setSelectedItems] = useState<(number | null)[]>([]);
  // const [isSelectedItemsUpdatedFlag, setIsSelectedItemsUpdatedFlag] = useState<boolean>(false);

  // const muiTextFieldTheme
  const color1 = "#2d6289";
  const textColor = "#25284e";

  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        // error: {
        //   main: color1,
        // },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              // borderBottomStyle: "solid",
              // borderBottomWidth: 1,
              boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.05) inset",
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
              paddingTop: "20px",
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "0px",
              fontWeight: "400",
              "&.Mui-disabled": {
                WebkitTextFillColor: textColor,
              },
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
              "&.Mui-disabled": {
                color: color1,
              },
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiTextField: {
          styleOverrides: {
            root: {
              // marginBottom: "1.8rem",
            },
          },
        },
      },
    });

  // const [eventCostList, setEventCostList] = useState<ICost[]>([]);
  // const [eventCostIdList, setEventCostIdList] = useState<number[]>([]);
  // const [eventVideoCostIdList, setVideoEventCostIdList] = useState<number[]>([]);
  // const [selectedVideoEventList, setSelectedVideoEventList] = useState<
  //   IOrderItem[]
  // >([]);
  // const [eventLocation, setEventLocation] = useState<ILocation>();
  // const [OrderItemCost, setOrderItemCost] = useState<number>(0);
  const [transactionAmount, setTransactionAmount] = useState<number>(
    storeTrasactionAmount
  );
  // const [addItemButtonDisabled, setAddItemButtonDisabled] = useState(true);

  const [Sections, setSections] = useState<ISection[]>(orderDetail.Sections);
  // const [Sections, setSections] = useState<ISection[]>([]);
  // const [memberCodes, setMemberCodes] = useState<IMemberCode[]>();

  const [initialRun, setinitialRun] = useState<boolean>(true);
  const [AddSectionItemsClicked, setAddSectionItemsClicked] =
    useState<boolean>(false);
  const [AddMembershipItemsClicked, setAddMembershipItemsClicked] =
    useState<boolean>(false);

  // current active orders are saved in ref for filtering purpose.
  // const membersActiveOrdersRef = useRef<IActiveOrder>();
  // const membersActiveFunctioOrdersRef = useRef<number[]>([]);
  // const membersActiveSeminarOrdersRef = useRef<number[]>([]);
  const membersActivememberShipOrderRef = useRef<number[]>([]);

  const [membersLastYearSections, setMembersLastYearSections] = useState<
    number[]
  >([]);

  const [orderPaymentInfoModalOpen, setOrderPaymentInfoModalOpen] =
    useState<boolean>(false);

  // to display the lables in UI only once if exist.
  // const [HasSeminarOrderItem, setHasSeminarOrderItem] =
  //   useState<boolean>(false);
  // const [HasFunctionOrderItem, setHasFunctionOrderItem] =
  //   useState<boolean>(false);
  const [HasMembershipOrderItem, setHasMembershipOrderItem] =
    useState<boolean>(false);
  const [HasSectionOrderItem, setHasSectionOrderItem] =
    useState<boolean>(false);
  // const [HasVideoOrderItem, setHasVideoOrderItem] = useState<boolean>(false);
  // const [AddVideoItemsClicked, setAddVideoItemsClicked] =
  //   useState<boolean>(false);

  // console.log("membersActiveOrders-props", props.membersActiveOrders);
  // console.log("Sections-props", props.Sections);
  // console.log("memberCodes-props", props.memberCodes);
  // console.log("videoEvents-props", props.videoEvents);

  useEffect(() => {
    console.log("order event detail: USEEFFECT CALLED");

    const initSelectedSections = () => {
      if (props.Sections !== undefined) {
        console.log("props.Sections is define");
        setSections(props.Sections);
      } else {
        console.log("props.Sections is undefine");
      }

      orderDetail.Orders.map((orderItem) => {
        console.log(
          "initSelectedSections-membershipItemList:",
          orderItem.membershipItemList
        );
        orderItem.membershipItemList.map((membershipItem) => {
          // console.log(
          //   "initSelectedSections-membershipItem:",
          //   membershipItem.SectionName,
          //   ":",
          //   membershipItem.Id
          // );
          // select selected items list to update checkbox
          setSelectedItems((selectedItems) => [
            ...selectedItems!,
            Number(membershipItem.Id),
          ]);

          // Set Total amount based on selected sections
          // setTransactionAmount((currentValue) => {
          //   return membershipItem.Fee !== null
          //     ? currentValue + membershipItem.Fee
          //     : currentValue;
          // });
          // console.log(
          //   "selectedItems,totalAmount:",
          //   selectedItems,
          //   "-",
          //   transactionAmount
          // );
        });
      });
    };

    // console.log("ConfigurationList:", configurationList);
    // console.log("MemberSection1", Sections);
    const getOrderListsForMemberID = () => {
      // membersActiveFunctioOrdersRef.current = [];
      // membersActiveSeminarOrdersRef.current = [];
      membersActivememberShipOrderRef.current = [];

      console.log("membersActiveOrders", props.membersActiveOrders);

      // props.membersActiveOrders.FunctioOrders.map((orderItem: any) => {
      //   if (orderItem.EventId === eventInfo.Id) {
      //     membersActiveFunctioOrdersRef.current = [
      //       ...membersActiveFunctioOrdersRef.current,
      //       orderItem.CostId,
      //     ];
      //   }
      // });

      // props.membersActiveOrders.SeminarOrders.map((orderItem: any) => {
      //   if (orderItem.EventId === eventInfo.Id) {
      //     membersActiveSeminarOrdersRef.current = [
      //       ...membersActiveSeminarOrdersRef.current,
      //       orderItem.CostId,
      //     ];
      //   }
      // });

      if (
        props.membersActiveOrders &&
        props.membersActiveOrders.memberShipOrderDetails &&
        props.membersActiveOrders.memberShipOrderDetails[0] &&
        props.membersActiveOrders.memberShipOrderDetails[0]
          .CurrentYearSections !== null &&
        props.membersActiveOrders.memberShipOrderDetails[0]
          .CurrentYearSections !== undefined
      ) {
        // props.membersActiveOrders?.memberShipOrderDetails[0]
        //     .CurrentYearSections ?? {

        membersActivememberShipOrderRef.current =
          props.membersActiveOrders?.memberShipOrderDetails[0]
            .CurrentYearSections!.split(",")
            .map(Number);

        // setting isSelected Flag in sections to false as they are active already

        membersActivememberShipOrderRef.current.map((activeSectionID) => {});
      }

      if (
        props.membersActiveOrders &&
        props.membersActiveOrders.memberShipOrderDetails &&
        props.membersActiveOrders.memberShipOrderDetails[0] &&
        props.membersActiveOrders!.memberShipOrderDetails[0]!
          .LastYearSections !== null &&
        props.membersActiveOrders!.memberShipOrderDetails[0]!
          .LastYearSections !== undefined
      ) {
        setMembersLastYearSections(
          props
            .membersActiveOrders!.memberShipOrderDetails[0]!.LastYearSections!.split(
              ","
            )
            .map(Number)
        );
      }
    };

    getOrderListsForMemberID();

    setHasMembershipOrderItem(orderDetail.HasMembershipOrderItem);
    setHasSectionOrderItem(orderDetail.HasSectionOrderItem);
    // setHasVideoOrderItem(orderDetail.HasVideoOrderItem);

    if (initialRun) {
      initSelectedSections();
      setSectionIsSelectedFlag(Sections);
      if (tempCurrentMember.IsCurrentYearDuePaid !== 1) {
        console.log("IsCurrentYearDuePaid NOT PAID");
        addMembershipItems();
      }
      setinitialRun(false);
    }
  }, [currentMember.Id]);

  // temp useEffect
  useEffect(() => {
    console.log("OrderItemCost-useeffect:");
    if (AddSectionItemsClicked) {
      // console.log("AddSectionItemsClicked triggered");
      // setTransactionAmount(storeTrasactionAmount);
      addSectionItems();
      setAddSectionItemsClicked(false);
    }

    if (AddMembershipItemsClicked) {
      console.log("AddMembershipItemsClicked triggered:");
      // setTransactionAmount(storeTrasactionAmount);
      addMembershipItems();
      setAddMembershipItemsClicked(false);
    }
  }, [AddSectionItemsClicked, AddMembershipItemsClicked]);

  useEffect(() => {
    // console.log("Select Item Changed: USEEFFECT CALLED");
  }, [selectedItems]);

  useEffect(() => {
    setTransactionAmount(storeTrasactionAmount); // Update transactionAmount when storeTrasactionAmount changes
  }, [storeTrasactionAmount]);

  useEffect(() => {
    setOrderItemsForComputeCost(orderDetail?.Orders);
  }, [orderDetail]);

  useEffect(() => {
    console.log("totalAmount");
    dispatch(
      storeUpdateOrder({
        key: "TransactionAmount",
        value: totalAmount,
      })
    );
  }, [totalAmount]);

  useEffect(() => {
    console.log("useEffect called on orderDetail");
    if (callAPIflag === true) {
      callCreateOrderAPI();
      setCallAPIflag(false);
    }
  }, [orderDetail]);
  // useEffect(() => {
  //   console.log(
  //     "orderItemsForComputeCost USEEFFECT CALLED:",
  //     orderDetail?.Orders
  //   );
  //   console.log("orderItemsForComputeCost", orderItemsForComputeCost);
  //   computeTotalAmount();
  // }, [orderItemsForComputeCost]);

  const setSectionIsSelectedFlag = (sectionList: any) => {
    if (typeof Sections !== "undefined") {
      // let orderItemCost = 0;
      const updatedSections = sectionList.map((section: ISection) => {
        //isChecked is a call back funtion
        const isChecked = (selectedFlag: ISelectedSections) => {
          return selectedFlag.Id === section.Id;
        };

        // SelectedSections come from current member and membersActivememberShipOrderRef
        // comes from active sections API call. with fresh data, both will alwaays be same
        const isSelected0 = SelectedSections?.some(isChecked) || false;
        const isSelected1 = !membersActivememberShipOrderRef.current.includes(
          section.Id
        );
        if (isSelected0 && isSelected1) {
          console.log("isSelected1:", section.SectionDescription);
        }
        if (section.isSelected) {
          console.log("isSelected:", section.SectionDescription);
        }
        const isSelected2 =
          selectedItems !== undefined
            ? selectedItems.includes(section.Id)
            : false;

        return {
          ...section,
          isSelected: section.isSelected || (isSelected0 && isSelected1),
        };
      });
      setSections(updatedSections);
      dispatch(
        storeUpdateOrder({
          key: "Sections",
          value: updatedSections,
        })
      );
      console.log("updatedSections:", updatedSections);

      // updatedSections.some((section: ISection) => {
      //   const isActive = membersActivememberShipOrderRef.current.some(
      //     (MemberCode) => MemberCode === section.Id
      //   );
      //   console.log(
      //     "updatedSections:",
      //     section.SectionName,
      //     "-",
      //     section.isSelected,
      //     "-isActive:",
      //     isActive
      //   );
      //   if (section.isSelected === true && !isActive) {
      //     setHasSectionOrderItem(true);
      //     dispatch(
      //       storeUpdateOrder({
      //         key: "HasSectionOrderItem",
      //         value: true,
      //       })
      //     );
      //     return true;
      //   }
      //   return false;
      // });
    } else {
      // console.log("section is undefined");
    }
  };

  const handleSectionChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    clickedSection: ISection
  ) => {
    // if (event.target.checked) {
    //   setSelectedItems((selectedItems) => [
    //     ...selectedItems!,
    //     Number(event.target.id),
    //   ]);
    //   // setOrderItemCost(OrderItemCost + clickedSection.Fee);
    // } else {
    //   setSelectedItems((prevSelectedItems) =>
    //     prevSelectedItems!.filter((item) => {
    //       return item !== Number(event.target.id);
    //     })
    //   );
    //   // setOrderItemCost(OrderItemCost - clickedSection.Fee);
    // }
    // // end

    // console.log("setSelectedItems:", setSelectedItems);
    // // console.log("SelectedMEmbershipItems:", Sections);
    // // setSections((previousSections) =>
    // //   previousSections.map((section) =>
    // //     section.Id === clickedSection.Id
    // //       ? { ...section, isSelected: true }
    // //       : section
    // //   )
    // // );
    console.log("SectionChange call back func called");
    dispatch(
      storeUpdateSectionItem({
        key: "Sections",
        value: clickedSection,
      })
    );
    setAddSectionItemsClicked(true);
  };

  const handleMemberCodeChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    clickedMemberCode: IMemberCode
  ) => {
    // if (event.target.checked) {
    //   setSelectedItems((selectedItems) => [
    //     ...selectedItems!,
    //     Number(event.target.id),
    //   ]);
    //   // setOrderItemCost(OrderItemCost + clickedSection.Fee);
    // } else {
    //   setSelectedItems((prevSelectedItems) =>
    //     prevSelectedItems!.filter((item) => {
    //       return item !== Number(event.target.id);
    //     })
    //   );
    //   // setOrderItemCost(OrderItemCost - clickedSection.Fee);
    // }
    // // end
    // console.log("setSelectedItems:", setSelectedItems);
    // // console.log("SelectedMEmbershipItems:", Sections);
    // // setSections((previousSections) =>
    // //   previousSections.map((section) =>
    // //     section.Id === clickedSection.Id
    // //       ? { ...section, isSelected: true }
    // //       : section
    // //   )
    // // );
    // dispatch(
    //   storeUpdateSectionItem({
    //     key: "Sections",
    //     value: clickedSection,
    //   })
    // );
  };

  const handleAddSectionItems = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setOrderPaymentInfoModalOpen(true);
    console.log("handleAddSectionItems Clicked");
    setAddSectionItemsClicked(true);
  };

  // calling this in useEffect to make sure state variables are updated before computing.
  const addSectionItems = () => {
    console.log("addSectionItems called");
    // e.preventDefault();
    dispatch(
      storeUpdateOrder({
        key: "MemberId",
        value: props.currentMember.Id!,
      })
    );

    setHasSectionOrderItem(true);
    dispatch(
      storeUpdateOrder({
        key: "HasSectionOrderItem",
        value: true,
      })
    );

    orderItem.EventType = "Membership";
    orderItem.EventId = null;
    orderItem.Location = null;
    orderItem.Costs = [];
    // orderItem.SelectedCostIdList = eventCostIdList;
    orderItem.OrderType = "Membership";
    // orderItem.MemberCodeId = null;
    // orderItem.MemberCode = null;
    orderItem.LastYearSections = [];
    orderItem.CurrentYearSections = [];
    orderItem.membershipItemList = [];

    let orderItemCost: number = 0;
    // console.log("Sections", Sections);
    // console.log("orderItem.membershipItemList", orderItem.membershipItemList);
    // console.log("addMembershipItems-Sections:", orderDetail.Sections);

    let totalCostLocal: number = 0;
    // Derive already-paid sections from active orders:
    const paidSectionIds: number[] =
      props.membersActiveOrders?.memberShipOrderDetailsUpdated
        ?.filter(
          (item: any) =>
            item.IsCurrentYearSection && !item.IsCurrentYearSectionNotPaid
        )
        .map((item: any) => item.Id) || [];
    
    const memberSectionIds: number[] = Array.isArray(currentMember.MemberSections)
      ? (currentMember.MemberSections
          .map((ms: IMemberSections) => ms.Id)
          .filter((id) => typeof id === "number") as number[])
      : [];
    orderDetail.Sections?.map((section: any) => {
      // orderItem.membershipItemList.map((item) => {
      //   console.log("section.Id-item.Id:", section.Id, "-", item.Id);
      // });
      // console.log("section:", section.SectionName, "-", section.isSelected);

      const isActive = membersActivememberShipOrderRef.current.some(
        (MemberCode) => MemberCode === section.Id
      );

      if (section.isSelected === true && !isActive) {
        // Zero cost if the section is already paid this year
        const isAlreadyPaid = paidSectionIds.includes(section.Id);
        // Also zero cost if the member has a section row (reactivation case)
        const existsInMember = memberSectionIds.includes(section.Id);
        const sectionFee = isAlreadyPaid || existsInMember ? 0 : section.Fee;
        
        // orderItemCost = orderItemCost + section.Fee;
        // console.log(
        //   "orderItemCost1:",
        //   orderItemCost,
        //   "-",
        //   section.SectionName,
        //   "-",
        //   section.Fee
        // );
        // Create a new membershipItem for each selected section
        const membershipItem: IMembership = {
          EventType: props.eventType,
          Id: section.Id,
          SectionName: section.SectionName,
          Fee: sectionFee,
        };
        orderItem.membershipItemList = [
          ...orderItem.membershipItemList,
          membershipItem,
        ];
        orderItem.CurrentYearSections = [
          ...(orderItem.CurrentYearSections ?? []),
          section.Id,
        ];
        //   if (membershipItem !== null && membershipItem?.Fee !== null) {
        //     totalCostLocal = totalCostLocal + membershipItem?.Fee;
        //   }
        //   console.log(
        //     "membershipItem:",
        //     membershipItem.SectionName,
        //     "-Amount:",
        //     totalCostLocal
        //   );
      }
      // setTotalAmount(totalCostLocal);
      // else {
      //   orderItem.membershipItemList.map((item) => {
      //     console.log("removed section.Id-item.Id:", section.Id, "-", item.Id);
      //   });
      //   orderItem.membershipItemList = orderItem.membershipItemList!.filter(
      //     (item) => {
      //       return item.Id !== section.Id;
      //     }
      //   );
      //   orderItem.CurrentYearSections = orderItem.CurrentYearSections!.filter(
      //     (item) => {
      //       return item !== section.Id;
      //     }
      //   );
      // }
    });
    // setTransactionAmount(orderItemCost);
    // dispatch(
    //   storeAddTransactionAmount({
    //     key: "TransactionAmount",
    //     value: orderItemCost,
    //   })
    // );
    // console.log("membershipItem1:", orderItem.membershipItemList);
    console.log("orderItem1:", orderItem);
    dispatch(
      storeUpdateSectionOrderItem({
        key: "Orders",
        value: orderItem,
      })
    );

    computeTotalAmount();
  };

  const computeTotalAmount = () => {
    let totalCostLocal: number = 0;
    orderDetail.Sections?.map((section: any) => {
      const isActive = membersActivememberShipOrderRef.current.some(
        (MemberCode) => MemberCode === section.Id
      );
      if (section.isSelected === true && !isActive) {
        const membershipItem: IMembership = {
          EventType: props.eventType,
          Id: section.Id,
          SectionName: section.SectionName,
          Fee: section.Fee,
        };

        if (membershipItem !== null && membershipItem?.Fee !== null) {
          totalCostLocal = totalCostLocal + membershipItem?.Fee;
        }
        console.log(
          "membershipItem:",
          membershipItem.SectionName,
          "-Amount:",
          totalCostLocal
        );
      }
    });
    if (currentMember !== null && currentMember?.MemberCodeFee !== null) {
      totalCostLocal = totalCostLocal + currentMember.MemberCodeFee;
      setTotalAmount(totalCostLocal);
      return;
    }
    setTotalAmount(totalCostLocal);
  };

  const handleAddMembershipItems = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setOrderPaymentInfoModalOpen(true);
    console.log("handleAddMembershipItems CALLED");
    // setAddMembershipItemsClicked(true);
    computeTotalAmount();
  };

  const handleMemberShipChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    console.log("handleMemberShipChange:", event.target.id);
    props.memberCodes &&
      props.memberCodes.map((memberCode) => {
        if (Number(event.target.id) === memberCode.Id) {
          console.log("memberCode:", memberCode);
          orderItem.OrderType = "Membership";
          orderItem.MemberCodeId = memberCode.Id; //tempCurrentMember.MemberCodeId;
          orderItem.MemberCode = memberCode.MemberCode;
          orderItem.MemberCodeFee = memberCode.Fee;
          orderItem.MemberCodeDesc = memberCode.Description;

          dispatch(
            updateCurrentMember({
              key: "MemberCodeId",
              value: Number(memberCode.Id),
            })
          );
          dispatch(
            updateCurrentMember({
              key: "MemberCode",
              value: memberCode.MemberCode,
            })
          );
          dispatch(
            updateCurrentMember({
              key: "MemberCodeFee",
              value: memberCode.Fee,
            })
          );
          dispatch(
            updateCurrentMember({
              key: "Description",
              value: memberCode.Description,
            })
          );
        }
      });
    console.log("orderItem3", orderItem);
    dispatch(
      storeUpdateSectionOrderItem({
        key: "Orders",
        value: orderItem,
      })
    );

    setCurrentMemberCodeId(Number(event.target.id));
  };

  const addMembershipItems = () => {
    dispatch(
      storeUpdateOrder({
        key: "MemberId",
        value: props.currentMember.Id!,
      })
    );
    setHasMembershipOrderItem(true);
    dispatch(
      storeUpdateOrder({
        key: "HasMembershipOrderItem",
        value: true,
      })
    );
    // console.log("addMembershipItems called:");
    orderItem.EventType = "Membership";
    orderItem.EventId = null;
    orderItem.Location = null;
    orderItem.Costs = [];
    orderItem.OrderType = "Membership";
    orderItem.MemberCodeId = currentMember.MemberCodeId; //tempCurrentMember.MemberCodeId;
    // orderItem.MemberCode = null;
    // orderItem.MemberCodeFee = null; //tempCurrentMember.MemberCodeFee;
    // orderItem.MemberCodeDesc = null;
    orderItem.MemberCode = currentMember.MemberCode;
    orderItem.MemberCodeFee = currentMember.MemberCodeFee;
    orderItem.MemberCodeDesc = currentMember.Description;
    orderItem.LastYearSections = [];
    orderItem.CurrentYearSections = [];
    orderItem.membershipItemList = [];

    console.log("orderItem2:", orderItem);
    dispatch(
      storeUpdateSectionOrderItem({
        key: "Orders",
        value: orderItem,
      })
    );
  };

  // const computeTotalAmount = () => {
  //   let computedAmount = 0;
  //   console.log("computeTotalAmount CALLED:", orderDetail ?? 0);
  //   orderDetail.Orders?.forEach((orderItem) => {
  //     // if (
  //     //   orderItem.OrderType === "Seminar" ||
  //     //   orderItem.OrderType === "Function"
  //     // ) {
  //     //   console.log("computeTotalAmount Seminar/Funtion1:", computedAmount);
  //     //   orderItem?.Costs?.forEach((costItem) => {
  //     //     computedAmount += costItem?.Cost ?? 0;
  //     //   });
  //     //   computedAmount += orderItem?.Locations?.Cost ?? 0;
  //     //   console.log(
  //     //     "computedAmount-compute:",
  //     //     orderItem?.Locations?.Cost ?? 0,
  //     //     ":",
  //     //     computedAmount
  //     //   );
  //     //   console.log("computeTotalAmount Seminar/Funtion2:", computedAmount);
  //     // }
  //     if (orderItem.OrderType === "Membership") {
  //       console.log("computeTotalAmount Section1:", computedAmount);
  //       orderItem?.membershipItemList.forEach((membershipItem: IMembership) => {
  //         console.log("membershipItem:", membershipItem);
  //         computedAmount += membershipItem?.Fee ?? 0;
  //       });
  //       console.log("computeTotalAmount Section2:", computedAmount);
  //     }
  //     if (
  //       orderItem.OrderType === "Membership" &&
  //       orderItem.MemberCodeId != 0 &&
  //       orderItem.MemberCodeId != null
  //     ) {
  //       console.log(
  //         "computeTotalAmount Membership1:",
  //         computedAmount,
  //         ":",
  //         tempCurrentMember
  //       );
  //       computedAmount += tempCurrentMember.MemberCodeFee ?? 0;
  //       console.log("computeTotalAmount Membership2:", computedAmount);
  //     }

  //     // if (orderItem.OrderType === "Video") {
  //     //   console.log("computeTotalAmount Video1:", computedAmount);
  //     //   console.log("orderItem", orderItem);
  //     //   computedAmount += orderItem?.VideoCost ?? 0;
  //     //   console.log("computeTotalAmount Video2:", computedAmount);
  //     // }

  //     dispatch(
  //       storeUpdateOrder({
  //         key: "TransactionAmount",
  //         value: computedAmount,
  //       })
  //     );

  //     // orderDetail.TransactionAmount += orderItem?.Locations?.Cost ?? 0;
  //   });

  //   // dispatch(
  //   //   storeAddTransactionAmount({
  //   //     key: "TransactionAmount",
  //   //     value: orderDetail?.TransactionAmount ?? 0,
  //   //   })
  //   // );
  // };

  const toCamelCase = (str: string) => {
    if (!str) {
      return ""; // or handle it based on your use case
    }
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word: string, index: number) => {
        return index === 0 ? word.toUpperCase() : word.toLowerCase();
      })
      .replace(/\s+/g, "");
  };

  const addOrderPaymentInfo = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("addOrderPaymentInfo CALLED");

    // if (member?.Id !== null) {
    //   dispatch(
    //     storeUpdateOrder({
    //       key: "MemberId",
    //       value: member?.Id!,
    //     })
    //   );
    //   dispatch(
    //     storeUpdateOrder({
    //       key: "TransactionAmount",
    //       value: transactionAmount,
    //     })
    //   );
    // }

    dispatch(
      storeUpdateOrder({
        key: "TransactionAmount",
        value: transactionAmount,
      })
    );
    console.log("addOrderItem CALLED");
    setCallAPIflag(true);
  };

  const callCreateOrderAPI = async () => {
    console.log("onSUBMIT:", orderDetail);
    // setModalOpen(false);
    const apiBody: any = orderDetail;
    const response = await OrderServices.createOrder(apiBody);
    // dispatch(resetOrderParameters());
    setOrderPaymentInfoModalOpen(false);
    console.log("response", response);
    // alert("response received");
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("Order Created successfully");
      // dispatch(resetOrderParameters());  I am doing this in useEffect
      // navigate("/order", { replace: true });
      // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

      dispatch(
        storeUpdateOrder({
          key: "TransactionAmount",
          value: 0,
        })
      );
      navigate("/member", { replace: false });

      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
      // navigate("/member", { replace: false });
      // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
      //  dispatch(screenChange("Events"));
    } else {
      alert(response.data.errors);
      console.log("error");
    }
  };

  const updatePaymentInfo = (e: any, date?: Date | null) => {
    switch (e.target.name) {
      case "ParticipantType":
        setParticipantType(e.target.value);
        break;
      case "TransactionType":
        dispatch(
          storeUpdateOrder({
            key: "TransactionType",
            value: e.target.value,
          })
        );
        break;

      case "DatePaid":
        dispatch(
          storeUpdateOrder({
            key: "DatePaid",
            value: e.target.value,
          })
        );

        break;

      case "CheckNumber":
        dispatch(
          storeUpdateOrder({
            key: "CheckNumber",
            value: e.target.value,
          })
        );
        break;

      case "AmountPaid":
        dispatch(
          storeUpdateOrder({
            key: "AmountPaid",
            value: e.target.value,
          })
        );
        break;

      case "LateFee":
        dispatch(
          storeUpdateOrder({
            key: "LateFee",
            value: e.target.value,
          })
        );
        break;

      case "AuthCode":
        dispatch(
          storeUpdateOrder({
            key: "AuthCode",
            value: e.target.value,
          })
        );
        break;

      case "PIcomments":
        dispatch(
          storeUpdateOrder({
            key: "comments",
            value: e.target.value,
          })
        );
        break;

      case "NoInvoiceFlag":
        dispatch(
          storeUpdateOrder({
            key: "NoInvoice",
            value: e.target.checked,
          })
        );
        break;
      default:
        console.log("default");
        break;
    }
  };

  return (
    <>
      <form
        key={1}
        className="form-wrapper"
        // onSubmit={addOrderItem}
        noValidate
      >
        {/* cost section */}
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ position: "relative" }}
        >
          {/* third row */}
          <div className="horizontal-wrapper-spacebetween">
            {props.eventType === "Sections" ? (
              <>
                <div
                  className="form-wrapper-vertical"
                  style={{ width: "100%" }}
                >
                  <div
                    className="form-wrapper"
                    style={{ height: "500px", width: "100%" }}
                  >
                    {typeof Sections != "undefined" ? (
                      <>
                        <div
                          className="sections-section"
                          style={{ height: "100%", width: "100%" }}
                        >
                          {Sections.map((section: ISection) => (
                            <OrderEditSectionMultipleOptionItems
                              section={section}
                              isActive={membersActivememberShipOrderRef.current.some(
                                (MemberCode) => MemberCode === section.Id
                              )}
                              selectedSections={selectedItems}
                              isLastYear={membersLastYearSections.some(
                                (MemberCode) => MemberCode === section.Id
                              )}
                              onChangeFunction={handleSectionChange}
                            />
                          ))}
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  {/* <div className="horizontal-wrapper-centeraligned">
                    <div className="membership-small-secondary-button-div ">
                      <button
                        className="button"
                        type="button"
                        onClick={(e) => handleAddSectionItems(e)}
                        // onClick={addMembershipItems}
                        // disabled={addItemButtonDisabled}
                      >
                        {HasSectionOrderItem
                          ? "Update Sections"
                          : "Add Sections"}
                      </button>
                    </div>
                  </div> */}
                </div>
              </>
            ) : (
              <></>
            )}

            {props.eventType === "Membership" ? (
              <>
                <div
                  className="form-wrapper-vertical"
                  style={{ width: "100%" }}
                >
                  <div
                    className="form-wrapper"
                    style={{ height: "500px", width: "100%" }}
                  >
                    {typeof props.memberCodes != "undefined" ? (
                      <>
                        {/*  has active membership Code */}
                        {currentMember.IsCurrentYearDuePaid ? (
                          <div
                            className="sections-section"
                            style={{ height: "100%", width: "100%" }}
                          >
                            {props.memberCodes.map(
                              (memberCode: IMemberCode) => (
                                <div
                                  className="order-checkboxgroup"
                                  style={{ width: "50%" }}
                                >
                                  <input
                                    id={String(memberCode.Id)}
                                    name="membercode"
                                    className="checkbox"
                                    type="radio"
                                    checked={
                                      currentMember.MemberCode ===
                                      memberCode.MemberCode
                                        ? true
                                        : false
                                    }
                                    disabled={
                                      currentMember.IsCurrentYearDuePaid &&
                                      dayjs().diff(
                                        currentMember.MembershipExpiresOn,
                                        "month"
                                      ) > -3
                                        ? true
                                        : false
                                    }
                                    // checked={isSelected}
                                    // disabled={true}
                                    // onChange={(event) => handleChecked(event, section.SectionName)}
                                  />
                                  <div>
                                    {/*  current member code will be BOLD */}
                                    {memberCode.MemberCode ===
                                    currentMember.MemberCode ? (
                                      <>
                                        <span
                                          style={{
                                            marginRight: "5px",
                                            fontWeight: "800",
                                          }}
                                        >
                                          {Intl.NumberFormat("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                          }).format(memberCode.Fee as number)}
                                        </span>
                                        <span style={{ fontWeight: "800" }}>
                                          {memberCode.MemberCode}:
                                        </span>
                                        <span style={{ fontWeight: "800" }}>
                                          {memberCode.Description}
                                        </span>
                                        <span
                                          style={{
                                            marginLeft: "5px",
                                            color: "#03c04A",
                                            fontWeight: "500",
                                          }}
                                        >
                                          ( "Active" )
                                        </span>
                                      </>
                                    ) : memberCode.MemberCode ===
                                      currentMember.AdvanceMemberCode ? (
                                      <>
                                        <span
                                          style={{
                                            marginRight: "5px",
                                            fontWeight: "800",
                                          }}
                                        >
                                          {Intl.NumberFormat("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                          }).format(memberCode.Fee as number)}
                                        </span>
                                        <span style={{ fontWeight: "800" }}>
                                          {memberCode.MemberCode}:
                                        </span>
                                        <span style={{ fontWeight: "800" }}>
                                          {memberCode.Description}
                                        </span>
                                        <span
                                          style={{
                                            marginLeft: "5px",
                                            color: "#03c04A",
                                            fontWeight: "500",
                                          }}
                                        >
                                          "(Next Adance)"
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <span style={{ marginRight: "5px" }}>
                                          {Intl.NumberFormat("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                          }).format(memberCode.Fee as number)}
                                        </span>
                                        <span>{memberCode.MemberCode}:</span>
                                        <span> {memberCode.Description}</span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        ) : (
                          // New user; No active membership Code
                          <div
                            className="sections-section"
                            style={{ height: "100%" }}
                          >
                            {props.memberCodes.map(
                              (memberCode: IMemberCode) => (
                                <div
                                  className="order-checkboxgroup"
                                  style={{ width: "50%" }}
                                >
                                  <input
                                    id={String(memberCode.Id)}
                                    name="membercode"
                                    className="checkbox"
                                    type="radio"
                                    checked={
                                      currentMemberCodeId ===
                                      Number(memberCode.Id)
                                        ? true
                                        : false
                                    }
                                    // disabled={
                                    //   tempCurrentMember.MemberCode !==
                                    //   memberCode.MemberCode
                                    //     ? true
                                    //     : false
                                    // }
                                    onChange={(event) =>
                                      handleMemberShipChange(event)
                                    }
                                  />
                                  <div>
                                    <span style={{ marginRight: "5px" }}>
                                      {Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                      }).format(memberCode.Fee as number)}
                                    </span>
                                    <span> {memberCode.MemberCode}</span>
                                    <span> {memberCode.Description}</span>

                                    <span
                                      style={{
                                        marginLeft: "5px",
                                        color: "#03c04A",
                                      }}
                                    ></span>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  {/* <div className="horizontal-wrapper-centeraligned">
                    <div className="membership-small-secondary-button-div ">
                      <button
                        className="button"
                        type="button"
                        onClick={(e) => handleAddMembershipItems(e)}
                        // onClick={addMembershipItems}
                        disabled={
                          tempCurrentMember.IsCurrentYearDuePaid &&
                          dayjs().diff(
                            tempCurrentMember.MembershipExpiresOn,
                            "month"
                          ) > -3
                            ? true
                            : false
                        }
                      >
                        {HasMembershipOrderItem
                          ? "Update Member Code"
                          : "Add Member Code"}
                      </button>
                    </div>
                  </div> */}
                </div>
              </>
            ) : (
              <></>
            )}
            <>
              {/* <div className="order-summary">
            // Order summary 
            <h5 className="order-header">ORDER SUMMARY</h5>
            <div className="order-items">
              {orderDetail.Orders.map((orderItems) => (
                <>
                  {orderItems.EventType === "Seminar" ? (
                    <>
                      <label className="orderitem-header">
                        {orderItems.EventName} (Seminar)
                      </label>

                      <div>
                        /// Render Costs items 
                        {orderItems.Costs &&
                          orderItems.Costs!.map((costItem) => (
                            <div
                              key={costItem.CostName}
                              className="horizontal-wrapper-rightaligned"
                            >
                              <label className="orderitem-label">
                                {costItem.CostName}
                              </label>
                              <label
                                style={{ width: "10%", paddingLeft: "0.5rem" }}
                              >
                                :
                              </label>
                              <span className="orderitem-value">
                                {Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                }).format(costItem.Cost as number)}
                              </span>
                            </div>
                          ))}

                        /// Render Location 
                        {orderItems.Locations !== null ? (
                          <>
                            <div className="horizontal-wrapper-rightaligned">
                              <label className="orderitem-label">
                                Location:{orderItems.Locations!.Location!}
                              </label>
                              <label
                                style={{ width: "10%", paddingLeft: "0.5rem" }}
                              >
                                :
                              </label>
                              <span className="orderitem-value">
                                {Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                }).format(orderItems.Locations!.Cost as number)}
                              </span>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ))}
              {orderDetail.Orders.map((orderItems) => (
                <>
                  {orderItems.EventType === "Function" ? (
                    <>
                      <label className="orderitem-header">
                        {orderItems.EventName} (Function)
                      </label>
                      <div>
                        /// Render Costs items 
                        {orderItems.Costs &&
                          orderItems.Costs!.map((costItem) => (
                            <div
                              key={costItem.CostName}
                              className="horizontal-wrapper-rightaligned"
                            >
                              <label className="orderitem-label">
                                {costItem.CostName}
                              </label>
                              <label
                                style={{ width: "10%", paddingLeft: "0.5rem" }}
                              >
                                :
                              </label>
                              <span className="orderitem-value">
                                {Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                }).format(costItem.Cost as number)}
                              </span>
                            </div>
                          ))}

                        /// Render Location 
                        {orderItems.Locations && (
                          <>
                            <div className="horizontal-wrapper-rightaligned">
                              <label className="orderitem-label">
                                Location:{orderItems.Locations!.Location}
                              </label>
                              <label
                                style={{ width: "10%", paddingLeft: "0.5rem" }}
                              >
                                :
                              </label>
                              <span className="orderitem-value">
                                {Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                }).format(orderItems.Locations!.Cost as number)}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ))}
              /// video summary 
              {orderDetail.Orders.map((orderItems) => (
                <>
                  {orderItems.EventType === "Video" ? (
                    <>
                      <label className="orderitem-header">
                        {orderItems.EventName} (Video)
                      </label>
                      <div>
                        /// Render Costs items 
                        {orderItems.Costs &&
                          orderItems.Costs!.map((costItem) => (
                            <div
                              key={costItem.CostName}
                              className="horizontal-wrapper-rightaligned"
                            >
                              <label className="orderitem-label">
                                {costItem.CostName}
                              </label>
                              <label
                                style={{ width: "10%", paddingLeft: "0.5rem" }}
                              >
                                :
                              </label>
                              <span className="orderitem-value">
                                {Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                }).format(costItem.Cost as number)}
                              </span>
                            </div>
                          ))}

                        /// Render Location 
                        {orderItems.Locations && (
                          <>
                            <div className="horizontal-wrapper-rightaligned">
                              <label className="orderitem-label">
                                Location:{orderItems.Locations!.Location}
                              </label>
                              <label
                                style={{ width: "10%", paddingLeft: "0.5rem" }}
                              >
                                :
                              </label>
                              <span className="orderitem-value">
                                {Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                }).format(orderItems.Locations!.Cost as number)}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ))}
              /// {orderItem && (
                      <div className="horizontal-wrapper-rightaligned">
                        <label className="orderitem-label">
                          {toCamelCase(orderItem.EventName)}
                        </label>
                        <label
                          style={{
                            width: "10%",
                            paddingLeft: "0.5rem",
                          }}
                        >
                          :
                        </label>
                        <span className="orderitem-value">
                          {Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(orderItem.VideoCost as number)}
                        </span>
                      </div>
                    )} 
               </div>
                ) : (
                  <></>
                )
              )}  ///

              <label className="orderitem-header">
                {HasSectionOrderItem ? "Sections" : <></>}
              </label>
              {orderDetail.Orders.map((orderItem) => (
                <>
                  {orderItem.EventType === "Membership" ? (
                    <>
                      {orderItem.membershipItemList.map((membershipItem) => (
                        <>
                          <div>
                            {membershipItem.SectionName && (
                              <>
                                <div className="horizontal-wrapper-rightaligned">
                                  <label className="orderitem-label">
                                    {membershipItem.SectionName}
                                  </label>
                                  <label
                                    style={{
                                      width: "10%",
                                      paddingLeft: "0.5rem",
                                    }}
                                  >
                                    :
                                  </label>
                                  <span className="orderitem-value">
                                    {Intl.NumberFormat("en-US", {
                                      style: "currency",
                                      currency: "USD",
                                    }).format(membershipItem.Fee as number)}
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        </>
                        // ) : (
                        //   <></>
                        //)}
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ))}

              <label className="orderitem-header">
                {HasMembershipOrderItem ? "Membership" : <></>}
              </label>
              {orderDetail.Orders.map((orderItem) =>
                orderItem.EventType === "Membership" &&
                orderItem.MemberCodeId !== null &&
                orderItem.MemberCodeId !== 0 ? (
                  <>
                    <div className="horizontal-wrapper-rightaligned">
                      <label className="orderitem-label">
                        {toCamelCase(orderItem.MemberCodeDesc ?? "")}
                      </label>
                      <label
                        style={{
                          width: "10%",
                          paddingLeft: "0.5rem",
                        }}
                      >
                        :
                      </label>
                      <span className="orderitem-value">
                        {Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(orderItem.MemberCodeFee as number)}
                      </span>
                    </div>
                  </>
                ) : (
                  <></>
                )
              )}
            </div>

             <div className="order-totalorder">
              <span className="orderitem-label"> TOTAL AMOUNT </span>
              <label style={{ width: "10%", paddingLeft: "0.5rem" }}>:</label>
              <span className="orderitem-value">
                {Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(transactionAmount as number)}
              </span>
            </div> 
          </div> */}
            </>
          </div>
        </div>
        <div className="horizontal-wrapper-centeraligned">
          <div className="membership-small-secondary-button-div ">
            <button
              className="button"
              type="button"
              onClick={(e) => handleAddMembershipItems(e)}
              // onClick={addMembershipItems}
              // disabled={
              //   currentMember.IsCurrentYearDuePaid &&
              //   dayjs().diff(currentMember.MembershipExpiresOn, "month") > -3
              //     ? true
              //     : false
              // }
            >
              {HasMembershipOrderItem ? "Update" : "Add"}
            </button>
          </div>
        </div>
        {/*  end of cost section  */}
      </form>
      <ReactModal
        isOpen={orderPaymentInfoModalOpen}
        onRequestClose={() => setOrderPaymentInfoModalOpen(false)}
        className="editinfo-modal-large"
        overlayClassName="overlay-dark"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading" style={{ marginBottom: "2rem" }}>
            Update Payment Information
          </h1>
          <PageLink
            onClick={() => {
              setOrderPaymentInfoModalOpen(false);
            }}
            style={{ marginBottom: "2rem" }}
          >
            Close
          </PageLink>
        </div>
        <form
          className="form-wrapper"
          onSubmit={(e) => addOrderPaymentInfo(e)}
          noValidate
        >
          <div className="input-field-div-wrapper">
            <select
              className="dropdown-control-large-insidetextfield"
              name="ParticipantType"
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            >
              <option value={""}>Select Participant Type</option>
              <option value="Attendee">Attendee</option>
              <option value="Moderator">Moderator</option>
              <option value="Speaker">Speaker</option>
            </select>
          </div>
          <div className="input-field-div-wrapper">
            <select
              className="dropdown-control-large-insidetextfield"
              name="TransactionType"
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            >
              <option value={""}>Select Payment Type </option>
              <option value="Online">American Express</option>
              <option value="Offline">Authorize.net</option>
              <option value="Check">Check</option>
              <option value="Discover">Discover</option>
              <option value="MasterCard">MasterCard</option>
              <option value="Visa">Visa</option>
              <option value="Offline">Website</option>
            </select>
          </div>

          <div style={{ width: "28%", marginBottom: "1.8rem" }}>
            <Controller
              control={control}
              name="DatePaid"
              // rules={{ required: "* required field" }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error },
              }) => (
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="datepicker-local"
                      label="Date Paid"
                      onChange={(date: Date | null) => {
                        const syntheticEvent = {
                          target: {
                            name: "DatePaid",
                            value: date
                              ? dayjs(date).format("YYYY-MM-DD")
                              : null,
                          },
                        };
                        updatePaymentInfo(syntheticEvent, date);
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              )}
            />
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="CheckNumber"
              name="CheckNumber"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="CheckNumber">
              Check Number
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="LateFee"
              name="LateFee"
              placeholder=""
              pattern="[0-9]*"
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="LateFee">
              Late Fee
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="AuthCode"
              name="AuthCode"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="AuthCode">
              Auth Code
            </label>
          </div>

          <div
            // className="textarea-wrapper"
            style={{ width: "48%" }}
          >
            <TextField
              className="textarea"
              id="PIcomments"
              name="PIcomments"
              placeholder="Notes"
              multiline
              rows={4}
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            />
          </div>

          <div
            className="horizontal-wrapper-spacebetween-center"
            style={{ width: "48%" }}
          >
            <>
              <label className="orderitem-header">
                {HasSectionOrderItem ? "Sections" : <></>}
              </label>
              {orderDetail.Orders.map((orderItem) => (
                <>
                  {orderItem.EventType === "Membership" ? (
                    <>
                      {orderItem.membershipItemList.map((membershipItem) => (
                        <>
                          {membershipItem.SectionName && (
                            <>
                              <div className="horizontal-wrapper-rightaligned">
                                <label className="orderitem-label">
                                  {membershipItem.SectionName}
                                </label>
                                <label
                                  style={{
                                    width: "10%",
                                    paddingLeft: "0.5rem",
                                  }}
                                >
                                  :
                                </label>
                                <span className="orderitem-value">
                                  {Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                  }).format(membershipItem.Fee as number)}
                                </span>
                              </div>
                            </>
                          )}
                        </>

                        // ) : (
                        //   <></>
                        //)}
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ))}

              <>
                {orderDetail.Orders.map((orderItem) =>
                  orderItem.EventType === "Membership" &&
                  orderItem.MemberCodeId !== null &&
                  orderItem.MemberCodeId !== 0 ? (
                    <>
                      <div className="horizontal-wrapper-rightaligned">
                        <label className="orderitem-label">
                          {toCamelCase(orderItem.MemberCodeDesc ?? "")}
                        </label>
                        <label
                          style={{
                            width: "10%",
                            paddingLeft: "0.5rem",
                          }}
                        >
                          :
                        </label>
                        <span className="orderitem-value">
                          {Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(orderItem.MemberCodeFee as number)}
                        </span>
                      </div>
                    </>
                  ) : (
                    <></>
                  )
                )}
              </>
              <div
                className="order-totalorder"
                style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
              >
                <span className="orderitem-label"> TOTAL AMOUNT </span>
                <label style={{ width: "10%", paddingLeft: "0.5rem" }}>:</label>
                <span className="orderitem-value">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(transactionAmount as number)}
                </span>
              </div>
            </>
          </div>
          {/* end of cost change  */}

          <div className="order-checkboxgroup" style={{ marginTop: "1rem" }}>
            <input
              id="NoInvoiceFlag"
              name="NoInvoiceFlag"
              className="checkbox"
              type="checkbox"
              onChange={(e) => updatePaymentInfo(e)}
            />
            <div>
              <span> No Invoice</span>
            </div>
          </div>

          <div className="horizontal-wrapper-centeralign">
            <div className="submit-button-div ">
              <Button type="submit">Submit</Button>
            </div>
          </div>
        </form>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default OrderEventDetail;
